import { useEffect, useState } from 'react';
import type { Workspace } from '@workspace/domain/workspace/Workspace';
import { RootFolderContent } from './RootFolderContent';
import { Loading } from '@framework/ui/atoms/Loading';
import { WorkspaceMemberRole } from '@workspace/domain/workspace';
import type { FolderId, UserId } from 'balus-common';
import { useWorkspaceMemberRoles } from '@workspace/domain/workspace/useWorkspaceMemberRoles';
import { Folder } from '@workspace/view-model-folder/domain/Folder';
import { useParams } from 'react-router-dom';
import type { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';
import { RootFolderTreeRepository } from '@workspace/view-model-folder/infrastructure/FolderTree';

type Props = {
  workspace: Workspace;
  currentUserId: UserId;
};

export const ViewModelRootFolder: React.FC<Props> = ({ workspace, currentUserId }: Props) => {
  const role = useWorkspaceMemberRoles(workspace.id)?.getRoleOf(currentUserId);
  const showEditMenu = !!(role && [WorkspaceMemberRole.admin, WorkspaceMemberRole.editor].includes(role));

  const [rootFolderTree, setRootFolderTree] = useState<RootFolderTree | null>(null);

  useEffect(() => {
    const repo = new RootFolderTreeRepository(workspace.id);
    repo.on((tree) => setRootFolderTree(tree));

    return () => repo.off();
  }, [workspace.id]);

  const { folderId = Folder.ROOT_ID } = useParams<{ folderId?: FolderId }>();

  return (
    <div className="mb-5 px-3">
      {rootFolderTree ? (
        <RootFolderContent
          showEditMenu={showEditMenu}
          workspace={workspace}
          rootFolderTree={rootFolderTree}
          folderId={folderId}
        />
      ) : (
        // rootFolderTree が null の間はローディング表示
        <Loading />
      )}
    </div>
  );
};
